// extracted by mini-css-extract-plugin
module.exports = {"subscriptionVoucherWarnModal":"c4","header":"c5","body":"c6","buttonRow":"c7","buttonWrapper":"c8","button":"c9","error":"c-"};